import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ServicesComponent } from './components/services/services.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
// import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ServiceDetailsComponent } from './components/services/service-details/service-details.component';
import { MembershipComponent } from './components/membership/membership.component';

export const routes: Routes = [
  { path: '', redirectTo: 'aboutus', pathMatch: 'full' },
  { path: 'aboutus', component: HomeComponent },
  // { path: 'aboutus', component: AboutUsComponent },
  { path: 'services', component: ServicesComponent },
  { path: 'services/:id', component: ServiceDetailsComponent },
  { path: 'membership', component: MembershipComponent },
  { path: 'sponsors', component: SponsorsComponent },
  {path: '**', component: HomeComponent},
  // { path: 'contactus', component: ContactUsComponent },
];
